import { faPaperclip } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonUIColor, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import useMailboxStore from "./hooks/useMailboxStore"
import useMarkAsReadMutation from "./hooks/useMarkAsReadMutation"
import { useViewMailModalStore } from "./ViewMailModal"
import { FamilyMail } from "../../../../types"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../../../util/analytics"
import { getChildFromMail, getMessageTime } from "../../../../util/mail"

const MailItem = ({ mail }: { mail: FamilyMail }) => {
  const { onOpen: onOpenViewMailModal } = useViewMailModalStore()
  const { selectedUserId } = useMailboxStore()
  const { t } = useTranslation()
  const childUser = getChildFromMail(mail, selectedUserId as number)
  const messageTime = getMessageTime(mail)
  const isInboxIn = mail.sender.id === childUser.id

  const isUnread = !mail.read_datetime && mail.sender.id === selectedUserId

  const markAsReadMutation = useMarkAsReadMutation()

  const onClickMailItem = () => {
    if (isUnread) markAsReadMutation.mutate(mail.id)
    trackAnalyticEvent(ANALYTIC_EVENTS.VIEW_FAMILY_MAIL)
    onOpenViewMailModal(mail)
  }

  return (
    <div
      className={`flex flex-col px-4 py-3 hover:bg-gray-100 rounded-md w-full ${
        !isUnread && "bg-gray-50"
      }`}
      onClick={onClickMailItem}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onClickMailItem()}
    >
      <div className="flex items-center gap-2 justify-between">
        <Typography variant="bodyXSmall" color={JoonUIColor.text.secondary}>
          {isInboxIn
            ? t("MAIL_FROM", { name: mail.sender.name })
            : t("MAIL_TO", { name: mail.receiver.name })}
        </Typography>
        <Typography variant="bodySmall" color={JoonUIColor.text.secondary}>
          {messageTime}
        </Typography>
      </div>
      <div className="flex items-start gap-1">
        {mail.shop_item_gift?.image_url ? (
          <img
            src={mail.shop_item_gift.image_url}
            className="w-4 h-4 mt-[1px]"
            alt={mail.shop_item_gift.name}
          />
        ) : (
          (mail.audio_attachment_url || mail.photo_attachment_url) && (
            <FontAwesomeIcon
              icon={faPaperclip}
              className="w-4 h-4 mt-[1px]"
              color={JoonUIColor.icon.neutral}
            />
          )
        )}
        <Typography variant={isUnread ? "bodySmallBold" : "bodySmall"}>
          {mail.body}
        </Typography>
      </div>
    </div>
  )
}

export default MailItem
